/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { Helmet } from 'react-helmet-async';
import ClearIcon from '@mui/icons-material/Clear';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import DownloadIcon from '@mui/icons-material/Download';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  Alert,
  Avatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Modal,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  Checkbox,
  Box
} from '@mui/material';
import ChalanFilter from './ChalanFilter';
import { blue, red } from '@mui/material/colors';
import { Add as AddIcon } from '@mui/icons-material';
import { spacing } from '@mui/system';
import { withStyles } from '@mui/styles';
import Loading from '../components/Loading';
import axios from '../../CustomAxios';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import swal from 'sweetalert';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

function createData(id, name, customer, description, data) {
  return {
    id,
    name,
    customer,
    description,
    data,
  };
}

const headCells = [
  { key: 'id', alignment: 'left', label: 'Challan ID' },
  { key: 'name', alignment: 'left', label: 'Challan Name' },
  { key: 'customer', alignment: 'left', label: 'Customer Company' },
  { key: 'description', alignment: 'left', label: 'Description' },
  { key: 'data.challan_date', alignment: 'left', label: 'Challan Date' },
];

const detailedCsvHeadCells = [
  { key: "challan_id", alignment: "center", label: "Challan ID" },
  { key: "challan_name", alignment: "center", label: "Challan Name" },
  { key: "customer_company", alignment: "center", label: "Customer Company" },
  { key: "challan_date", alignment: "center", label: "Challan Date" },
  { key: "job_id", alignment: "center", label: "Job ID" },
  { key: "plate_name", alignment: "center", label: "Plate Dimensions" },
  { key: "baking_cost", alignment: "center", label: "Baking Cost" },
  { key: "baking_quantity", alignment: "center", label: "Baking Qty" },
  { key: "print_cost", alignment: "center", label: "Print Cost" },
  { key: "print_quantity", alignment: "center", label: "Print Qty" },
  { key: "selling_cost", alignment: "center", label: "Selling Cost" },
  { key: "plate_quantity", alignment: "center", label: "Plate Qty" },
  { key: "row_cost", alignment: "center", label: "Row Cost (Pre-Tax)" },
  { key: "row_cost_with_taxes", alignment: "center", label: "Total Cost (With Tax)" },
  { key: "cost", alignment: "center", label: "Cost" },
];

const EnhancedTableHead = (props) => {
  const { download, viewPermission, editPermission, deletePermission, numSelected, onSelectAllClick } = props;
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [head, setHeads] = useState(headCells);
  useEffect(() => {
    setHeads((prev) => [
      ...prev,
      { id: 'uploaded', alignment: 'center', label: 'Challan Uploaded' },
    ]);

    if (download) {
      setHeads((prev) => [...prev, { id: 'download', alignment: 'center', label: 'Download' }]);
      if (authData?.type !== 'customer_user') {
        setHeads((prev) => [
          ...prev,
          { id: 'sendMail', alignment: 'center', label: 'Mail Challan' },
        ]);
      }
    }
    if (viewPermission) {
      setHeads((prev) => [...prev, { id: 'view', alignment: 'center', label: 'View' }]);
    }
    if (editPermission) {
      setHeads((prev) => [...prev, { id: 'edit', alignment: 'center', label: 'Edit' }]);
    }
    if (deletePermission) {
      setHeads((prev) => [...prev, { id: 'delete', alignment: 'center', label: 'Delete' }]);
    }
    setHeads((prev) => [...prev, { id: 'Delete Documents', alignment: 'center', label: 'Delete Documents' }]);

  }, [download, viewPermission, editPermission, deletePermission]);

  return (
    <TableHead>
      <TableRow>
        {(download && authData?.type !== 'customer_user') && <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < props.rowCount}
            checked={props.rowCount > 0 && numSelected === props.rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>}
        {head.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const getCompanies = async (setCompany, setApCompany) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company?limit=500`,
      config
    );

    if (data.success) {
      setCompany(data.data.data);
    }

    const apCompany = await axios.get(`/api/v1/${authData?.type}/ap_company`, config);
    if (apCompany.data.success) {
      setApCompany(apCompany.data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const EnhancedTableToolbar = (props) => {
  const [company, setCompany] = useState([]);
  const [apCompany, setApCompany] = useState([]);

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('AuthData'));

  useEffect(() => {
    getCompanies(setCompany, setApCompany);
  }, []);

  const {
    auths,
    setFilter,
    setBill,
    rows,
    setSelectedCompany,
    bill,
    selectedCompany,
    job_id,
    challan_id,
    setOnSearch,
    setJobSearch,
    setChallanSearch,
    createdDateFrom,
    setCreatedDateFrom,
    createdDateTo,
    setCreatedDateTo,
    searchType,
    setSearchType,
    leftDelivery,
    setLeftDelivery,
    clientAccept,
    setClientAccept,
    selectedApCompany,
    setSelectedApCompany,
    csvPermission,
    numSelected,
    handleBulkEmails,
    handleBulkAccept,     // <-- new prop
    selectedChallanIds,
    csvChallanData,
    setSelectedChallanIds,
  } = props;

  const authData = JSON.parse(localStorage.getItem('AuthData'));

  let timestamp = moment().format('DD-MM-YY HH:mm');

  // Simple CSV data with cost column
  const simpleCsvData = rows.map(row => ({
    id: row.id,
    name: row.name,
    customer: row.customer,
    description: row.description,
    challan_date: row.data?.challan_date ? moment(row.data.challan_date).format('DD/MM/YYYY') : '',
    cost: row.data?.totalPrice ?? 0,
  }));

  const simpleCsvHeaders = [
    { key: 'id', alignment: 'left', label: 'Challan ID' },
    { key: 'name', alignment: 'left', label: 'Challan Name' },
    { key: 'customer', alignment: 'left', label: 'Customer Company' },
    { key: 'description', alignment: 'left', label: 'Description' },
    { key: 'challan_date', alignment: 'left', label: 'Challan Date' },
    { key: 'cost', alignment: 'left', label: 'Cost' },
  ];

  const csvReport = {
    filename: `Challans_${timestamp}.csv`,
    headers: simpleCsvHeaders,
    data: simpleCsvData,
  };

  const csvChallanReport = {
    filename: `Detailed_Challans_${timestamp}.csv`,
    headers: detailedCsvHeadCells,
    data: csvChallanData,
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
        setSearchType(searchType);
      }}
    >
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='h6' id='tableTitle'>
          Challans
        </Typography>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          {numSelected > 0 && userData.type !== "customer_user" && (
            <>
              <Button
                color="primary"
                variant="contained"
                onClick={() => handleBulkEmails(selectedChallanIds)}
                sx={{ mr: 2 }}
              >
                Send Bulk Emails
              </Button>
              {(userData.type === "super_admin" || auths?.user?.role?.permissions?.includes("bulk_accept_challan")) && <Button
                color="secondary"
                variant="contained"
                onClick={() => handleBulkAccept(selectedChallanIds)}
                sx={{ mr: 2 }}
              >
                Bulk Accept
              </Button>}
            </>
          )}
          {csvPermission && authData.type === "super_admin" && (
            <CSVLink
              style={{ color: "green", textDecoration: "none" }}
              {...csvChallanReport}
            >
              <Button
                variant="outlined"
                sx={{ ml: 2, mr: 2 }}
                endIcon={<DownloadIcon />}
              >
                Detailed CSV
              </Button>
            </CSVLink>
          )}
          {csvPermission && (
            <CSVLink style={{ color: 'green', textDecoration: 'none' }} {...csvReport}>
              <Button
                variant='outlined'
                sx={{ ml: 2, mr: 2 }}
                endIcon={<DownloadIcon />}
                style={{ color: '#green' }}
              >
                CSV
              </Button>
            </CSVLink>
          )}

          <TextField
            select
            size='small'
            label='Search on'
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            sx={{ width: '108px' }}
          >
            <MenuItem key='challan' value='challan'>
              CHALLAN
            </MenuItem>
            <MenuItem key='job' value='job'>
              JOBS
            </MenuItem>
          </TextField>

          <TextField
            value={searchType === 'job' ? job_id : challan_id}
            size='small'
            sx={{ margin: '0 8px' }}
            label={searchType === 'job' ? 'Search Jobs' : 'Search Challans'}
            placeholder={searchType === 'job' ? 'Job ID' : 'Challan ID'}
            onChange={(e) => {
              if (searchType === 'job') {
                setJobSearch(e.target.value);
                setChallanSearch('');
                setSearchType('job');
              } else if (searchType === 'challan') {
                setChallanSearch(e.target.value);
                setJobSearch('');
                setSearchType('challan');
              }
            }}
          />

          <Button endIcon={<SearchIcon />} variant='contained' type='submit' sx={{ mr: 2 }}>
            Search
          </Button>

          <div>
            <ChalanFilter
              setFilter={setFilter}
              companies={company}
              bill={bill}
              setBill={setBill}
              apCompanies={apCompany}
              setSelectedCompany={setSelectedCompany}
              selectedCompany={selectedCompany}
              createdDateFrom={createdDateFrom}
              setCreatedDateFrom={setCreatedDateFrom}
              createdDateTo={createdDateTo}
              setCreatedDateTo={setCreatedDateTo}
              leftDelivery={leftDelivery}
              setLeftDelivery={setLeftDelivery}
              clientAccept={clientAccept}
              setClientAccept={setClientAccept}
              selectedApCompany={selectedApCompany}
              setSelectedApCompany={setSelectedApCompany}
            />
          </div>
          {userData && userData.type !== 'customer_user' && (
            <div>
              <Tooltip title='Create Challan'>
                <IconButton aria-label='Create Challan' size='large'>
                  <AddIcon onClick={() => navigate('/dashboard/challan/create-challan')} />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </div>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  rows,
  setRows,
  setFilter,
  auths,
  setBill,
  setSelectedCompany,
  bill,
  selectedCompany,
  download,
  viewPermission,
  user,
  editPermission,
  up,
  setUp,
  deletePermission,
  challan_id,
  job_id,
  setJobSearch,
  setChallanSearch,
  setOnSearch,
  getChalan,
  searchType,
  setSearchType,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  leftDelivery,
  setLeftDelivery,
  clientAccept,
  setClientAccept,
  selectedApCompany,
  setSelectedApCompany,
  csvPermission,
  selectedChallanIds,
  setSelectedChallanIds,
  csvChallanData,
}) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('customer');
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [images, setImages] = useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const inputFile = useRef(null);
  const handleOpen = () => setOpenModal(true);
  const handleDown = () => setOpenModal(false);
  const formData = new FormData();
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState(false);
  const [challanId, setChallanId] = useState();

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  // Bulk email function (existing)
  const handleBulkEmails = async (ids) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      const results = [];

      for (const id of ids) {
        try {
          const { data } = await axios.get(
            `/api/v1/${authData?.type}/challan/${id}/generate_pdf/send_email`,
            config
          );

          if (data.success) {
            results.push({ id, status: 'success', message: `Email sent for challan ${id}` });
          } else {
            results.push({ id, status: 'error', message: data.message || 'Unknown error' });
          }
        } catch (error) {
          results.push({ id, status: 'error', message: error.message || 'Unknown error' });
        }
      }

      setLoader(false);

      if (results.every(result => result.status === 'success')) {
        setMessage("All emails sent successfully");
      } else {
        setMessage("Some emails failed to send");
      }

      setFilter(true);
      return results;
    } catch (e) {
      setLoader(false);
      console.log(e);
      setMessage("An error occurred while sending emails");
      return false;
    }
  };

  // NEW: Bulk accept function
  const handleBulkAccept = async (ids) => {
    if (!ids.length) return;
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      const { data } = await axios.post(
        `/api/v1/${authData?.type}/challan/bulk/accept`,
        { challan_ids: ids },
        config
      );

      if (data.success) {
        setMessage('Challans accepted successfully');
        setSuccess(true);
        setErr('');
        setSelectedChallanIds([]);        // clear selection
        setFilter(true);                  // refresh the list
        snackRef.current.click();
      } else {
        throw new Error(data.message || 'Bulk accept failed');
      }
    } catch (error) {
      console.error(error);
      setErr(error.response?.data?.error || error.message || 'Bulk accept failed');
      setSuccess(false);
      snackRef.current.click();
    } finally {
      setLoader(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const currentPageIds = rows.map(row => row.data._id);
      const newSelected = [...selectedChallanIds];

      // Add only up to 10 items
      currentPageIds.forEach(id => {
        if (newSelected.length < 10 && !newSelected.includes(id)) {
          newSelected.push(id);
        }
      });

      setSelectedChallanIds(newSelected);
    } else {
      // Remove only current page items
      const currentPageIds = new Set(rows.map(row => row.data._id));
      setSelectedChallanIds(prev =>
        prev.filter(id => !currentPageIds.has(id))
      );
    }
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selectedChallanIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      if (selectedChallanIds.length >= 10) return;
      newSelected = [...selectedChallanIds, id];
    } else {
      newSelected = selectedChallanIds.filter(item => item !== id);
    }

    setSelectedChallanIds(newSelected);
  };

  // Calculate number of selected items on current page
  const numSelectedOnPage = selectedChallanIds.filter(id =>
    rows.some(row => row.data._id === id)
  ).length;

  const isSelected = (id) => selectedChallanIds.includes(id);

  const downloadChalan = async (chalan) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const comp = user?.customer_company?._id;
      let url =
        process.env.NODE_ENV === 'development'
          ? ''
          : process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      if (authData?.type === 'customer_user') {
        url += `/api/v1/${authData?.type}/${comp}/challan/${chalan._id}/generate_pdf`;
      } else {
        url += `/api/v1/${authData?.type}/challan/${chalan._id}/generate_pdf`;
      }
      const res = await fetch(url, {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
        method: 'GET',
      });
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display:none';
      const file = await res.blob();
      const downloadUrl = URL.createObjectURL(file);
      a.href = downloadUrl;
      a.download = `${chalan.challan_id}-${chalan.customer_company.name
        .split(' ')
        .join('-')}-${new Date(chalan.challan_date).toISOString().slice(0, 10)}.pdf`;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const sendEmailToCustomer = async (id) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      let url = `/api/v1/${authData?.type}/challan/${id}/generate_pdf/send_email`;

      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };
      const { data } = await axios.get(url, config);
      if (data.success) {
        setMessage('Mail Sent Successfully');
        setLoader(false);
        setFilter(true);
        setSuccess(true);
        setErr('');
        snackRef.current.click();
      }
    } catch (error) {
      setErr('Some error in sending mail');
      setSuccess(false);
      setLoader(false);
    }
  };

  const deleteChalan = async (id) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      const { data } = await axios.delete(`/api/v1/${authData.type}/challan/${id}`, config);

      if (data.success) {
        setMessage('Challan Deleted Successfully');
        setFilter(true);
        setLoader(false);
        setSuccess(true);
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e.response.data.error);
      setSuccess(false);
      snackRef.current.click();
    }
  };

  const downloadSignedChalan = async (chalan, key) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const comp = user?.customer_company?._id;
      let PROD_URL = '';
      if (process.env.NODE_ENV === 'development') {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      let url = '';
      if (authData?.type === 'customer_user') {
        url = `/api/v1/${authData?.type}/${comp}/media/${key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/${key}`;
      }

      fetch(PROD_URL + url, {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
        method: 'GET',
      }).then(async (res) => {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display:none';
        const file = await res.blob();
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = `${chalan.challan_id}-${chalan.customer_company.name}-${new Date(
          chalan.customer_accept_date
        ).toLocaleDateString()}-${new Date(chalan.customer_accept_date).toLocaleTimeString()}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        setLoader(false);
      });
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const uploadSignedChalan = async () => {
    try {
      setLoader(true);
      handleDown();
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };
      formData.set('customer_signed_doc', images);
      const { data } = await axios.put(
        `/api/v1/${authData?.type}/challan/${challanId}/signed_challan`,
        formData,
        config
      );
      if (data.success) {
        setLoader(false);
        setImages({});
        setBill(null);
        setSuccess(true);
        setErr('');
        snackRef.current.click();
        setMessage('Challan Uploaded successfully');
        setFilter(true);
      }
    } catch (e) {
      setLoader(false);
      setSuccess(false);
      setErr(e.response.data.error);
      snackRef.current.click();
      console.log(e);
    }
  };
  const BigAvatar = styled(Avatar)`
    width: 120px;
    height: 120px;
    text-align: center;
    margin: 0 auto ${(props) => props.theme.spacing(5)};
  `;

  const onButtonClick = () => {
    inputFile.current.click();
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const fileSelectedHandler = (e) => {
    setImages(e.target.files[0]);
  };
  const deleteSignedChalan = async (challanId) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      await axios.delete(
        `/api/v1/${authData?.type}/challan/${challanId}/signed_challan`,
        config
      );
      setLoader(false);
      setImages({});
      setBill(null);
      setSuccess(true);
      setErr('');
      snackRef.current.click();
      setMessage('Challan Uploaded successfully');
      setFilter(true);
    } catch (e) {
      setLoader(false);
      setSuccess(false);
      setErr(e.response.data.error);
      snackRef.current.click();
      console.log(e);
    }
  };

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: 'none' }}
        onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity='error'>
            {err}
          </Alert>
        ) : (
          <Alert mt={2} mb={4} severity='success'>
            {message}
          </Alert>
        )}
      </Snackbar>
      <Modal
        open={openModal}
        onClose={handleDown}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={12} lg={12}>
              <Typography color='primary' variant='h6' gutterBottom>
                Upload Signed Challan
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography component='h1' variant='h4' align='center' gutterBottom>
                Click Below to Upload documents
              </Typography>
              <BigAvatar onClick={onButtonClick} src='/static/img/images/upload.png' />
              <input
                type='file'
                id='file'
                ref={inputFile}
                accept='.png, .jpg, .jpeg, .pdf'
                onChange={fileSelectedHandler}
                style={{ display: 'none' }}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              {images.type ? (
                <Paper style={{ display: 'flex', alignItems: 'center' }} mt={3} m={2}>
                  <Box
                    m={2}
                    component='img'
                    width='80px'
                    height='80px'
                    onClick={() => window.open(URL.createObjectURL(images))}
                    src={
                      images?.type === 'image/png' ||
                        images?.type === 'image/jpg' ||
                        images?.type === 'image/jpeg'
                        ? URL.createObjectURL(images)
                        : '/static/img/images/pdf.png'
                    }
                  />
                  <TextField
                    fullWidth
                    margin='dense'
                    m={2}
                    value={images.name}
                    id='standard-required'
                    label='Document Name'
                  />
                  <Button onClick={uploadSignedChalan}>Upload Challan</Button>
                </Paper>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {!loader ? (
        <Paper>
          <EnhancedTableToolbar
            auths={auths}
            setBill={setBill}
            setOnSearch={setOnSearch}
            job_id={job_id}
            challan_id={challan_id}
            setJobSearch={setJobSearch}
            setChallanSearch={setChallanSearch}
            setFilter={setFilter}
            createdDateFrom={createdDateFrom}
            setCreatedDateFrom={setCreatedDateFrom}
            createdDateTo={createdDateTo}
            setCreatedDateTo={setCreatedDateTo}
            selectedCompany={selectedCompany}
            numSelected={selectedChallanIds.length}
            setSelectedCompany={setSelectedCompany}
            bill={bill}
            rows={rows}
            searchType={searchType}
            setSearchType={setSearchType}
            leftDelivery={leftDelivery}
            setLeftDelivery={setLeftDelivery}
            clientAccept={clientAccept}
            setClientAccept={setClientAccept}
            selectedApCompany={selectedApCompany}
            setSelectedApCompany={setSelectedApCompany}
            csvPermission={csvPermission}
            handleBulkEmails={handleBulkEmails}
            handleBulkAccept={handleBulkAccept}   // <-- pass new function
            selectedChallanIds={selectedChallanIds}
            csvChallanData={csvChallanData}
            setSelectedChallanIds={setSelectedChallanIds}
          />
          <StyledTableContainer>
            <Table size={'small'}>
              <EnhancedTableHead
                numSelected={selectedChallanIds.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                viewPermission={viewPermission}
                download={download}
                editPermission={editPermission}
                deletePermission={deletePermission}
              />
              <TableBody>
                {rows.map((row, index) => {
                  const isItemSelected = isSelected(row?.data?._id);
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClickRow(event, row?.data?._id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.id}`}
                      selected={isItemSelected}
                    >
                      {(download && authData?.type !== 'customer_user') && <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': `enhanced-table-checkbox-${index}`,
                          }}
                        />
                      </TableCell>}
                      <Tooltip
                        title={
                          <ol style={{ paddingLeft: 12 }}>
                            {row?.data?.jobs.map((job) => (
                              <li key={job.job_id}>{job.job_id}</li>
                            ))}
                          </ol>
                        }
                        placement='right'
                        arrow
                      >
                        <TableCell align='left' style={{ cursor: 'pointer' }}>
                          {row?.id}
                        </TableCell>
                      </Tooltip>
                      <TableCell align='left'>{row?.name}</TableCell>
                      <TableCell align='left'>{row?.customer}</TableCell>
                      <TableCell align='left'>{row?.description}</TableCell>
                      <TableCell align='left'>
                        {moment(new Date(row?.data?.challan_date)).format('DD/MM/YYYY')}
                      </TableCell>

                      {row?.data?.customer_signed_doc_uploaded ? (
                        <TableCell align='center'>
                          <div>
                            <DownloadDoneIcon
                              onClick={() => {
                                downloadSignedChalan(
                                  row?.data,
                                  row?.data?.customer_signed_doc?.Key
                                );
                              }}
                              style={{ cursor: 'pointer', color: blue[500] }}
                            />
                          </div>
                        </TableCell>
                      ) : (authData?.type === 'super_admin' && row?.data?.is_left_for_delivery) ||
                        (user?.role?.permissions.includes('upload_signed_challan') &&
                          row?.data?.is_left_for_delivery) ? (
                        <TableCell align='center'>
                          <div>
                            <CloudUploadIcon
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                handleOpen();
                                setChallanId(row.data._id);
                              }}
                            />
                          </div>
                        </TableCell>
                      ) : (
                        <TableCell align='center'>
                          <div>
                            <ClearIcon style={{ color: red[500] }} />
                          </div>
                        </TableCell>
                      )}
                      {download ? (
                        <TableCell align='center'>
                          <DownloadIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => downloadChalan(row?.data)}
                          />
                        </TableCell>
                      ) : null}
                      {download && authData?.type !== 'customer_user' ? (
                        <TableCell align='center'>
                          <Tooltip title={`Last Sent: ${row?.data?.last_sent
                            ? moment(row.data.last_sent).utcOffset("+05:30").format("DD-MM-YYYY hh:mm A")
                            : "Send Email"
                            }`}>
                            <AttachEmailIcon
                              style={{ cursor: 'pointer', color: 'green' }}
                              onClick={() => sendEmailToCustomer(row?.data?._id)}
                            />
                          </Tooltip>
                        </TableCell>
                      ) : null}

                      {viewPermission ? (
                        <TableCell align='center'>
                          <VisibilityIcon
                            style={{ cursor: 'pointer', color: 'green' }}
                            onClick={() =>
                              navigate(`/dashboard/challan/challan-details/${row.data._id}`, {
                                state: { challan: row?.data },
                              })
                            }
                          />
                        </TableCell>
                      ) : null}
                      {editPermission ? (
                        <TableCell align='center'>
                          <Tooltip
                            title={
                              row.data?.customer_signed_doc_uploaded
                                ? 'Challan accepted by customer'
                                : 'Edit Challan'
                            }
                          >
                            <EditIcon
                              style={{
                                cursor: 'pointer',
                                color: row.data?.customer_signed_doc_uploaded ? '#ccc' : 'darkblue',
                              }}
                              onClick={() => {
                                if (!row.data?.customer_signed_doc_uploaded) {
                                  navigate(`/dashboard/challan/update-challan/${row.data._id}`, {
                                    state: { challan: row?.data },
                                  });
                                }
                              }}
                            />
                          </Tooltip>
                        </TableCell>
                      ) : null}
                      {deletePermission ? (
                        <TableCell align='center'>
                          <DeleteIcon
                            style={{
                              cursor: 'pointer',
                              color: row.data?.customer_signed_doc_uploaded ? '#ccc' : 'red',
                            }}
                            onClick={() => {
                              if (!row.data?.customer_signed_doc_uploaded) {
                                swal({
                                  title: 'Are you sure?',
                                  text: 'You want to delete this challan',
                                  icon: 'warning',
                                  buttons: ['No', 'Yes'],
                                  dangerMode: true,
                                }).then((res) => {
                                  if (res) {
                                    deleteChalan(row?.data?._id);
                                  }
                                });
                              }
                            }}
                          />
                        </TableCell>
                      ) : null}
                      <TableCell align='center'>
                        <RemoveCircleIcon
                          style={{
                            cursor: 'pointer',
                            color: (row.data?.customer_signed_doc_uploaded && !row.data?.bill_created) ? 'red' : '#ccc',
                          }}
                          onClick={() => {
                            if ((row.data?.customer_signed_doc_uploaded && !row.data?.bill_created)) {
                              swal({
                                title: 'Are you sure?',
                                text: 'You want to delete this challan documents',
                                icon: 'warning',
                                buttons: ['No', 'Yes'],
                                dangerMode: true,
                              }).then((res) => {
                                if (res) {
                                  deleteSignedChalan(row?.data?._id);
                                }
                              });
                            }
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </StyledTableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 250]}
            component='div'
            count={total_results}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Loading />
      )}
    </div>
  );
}

function Chalan({ auths }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [bill, setBill] = useState(searchParams.get('bill_created') || null);
  const [clientAccept, setClientAccept] = useState(searchParams.get('cust_accept') || null);
  const [leftDelivery, setLeftDelivery] = useState(searchParams.get('left_for_delivery') || null);
  const [selectedCompany, setSelectedCompany] = useState(
    searchParams.get('customer_company_id') || ''
  );
  const [selectedApCompany, setSelectedApCompany] = useState(searchParams.get('ap_company') || '');
  const [download, setDownload] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  const [user, setUser] = useState([]);
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [up, setUp] = useState(0);
  const [filter, setFilter] = useState(true);

  const [challanSearch, setChallanSearch] = useState(searchParams.get('challan_search') || '');
  const [jobSearch, setJobSearch] = useState(searchParams.get('job_search') || '');

  const [createdDateFrom, setCreatedDateFrom] = useState(
    searchParams.get('challan_created_from') || ''
  );
  const [createdDateTo, setCreatedDateTo] = useState(searchParams.get('challan_created_to') || '');
  const [searchType, setSearchType] = useState('challan');

  const [page, setPage] = React.useState(
    searchParams.get('page') ? Number(searchParams.get('page')) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get('limit') ? Number(searchParams.get('limit')) : 25
  );
  const [total, setTotal] = useState(0);
  const [onSearch, setOnSearch] = useState(false);
  const [selectedChallanIds, setSelectedChallanIds] = useState([]);
  const [csvChallanData, setCsvChallanData] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const changeParams = (queryPage, queryLimit) => {
    let query = `?`;
    const id = auths?.user?.customer_company?._id;
    let customer_company_id = searchParams.get('customer_company_id');
    let bill_created = searchParams.get('bill_created');
    let cust_accept = searchParams.get('cust_accept');
    let left_for_delivery = searchParams.get('left_for_delivery');
    let search_keyword = searchParams.get('search_keyword');
    let bill_id = searchParams.get('bill_id');
    let challan_created_from = searchParams.get('challan_created_from');
    let challan_created_to = searchParams.get('challan_created_to');
    let apcompany = searchParams.get('ap_company') || '';

    if (customer_company_id) {
      query += `&customer_company_id=${customer_company_id}`;
    }
    if (bill_created) {
      query += `&bill_created=${bill_created}`;
    }
    if (cust_accept) {
      query += `&cust_accept=${cust_accept}`;
    }
    if (left_for_delivery) {
      query += `&left_for_delivery=${left_for_delivery}`;
    }
    if (search_keyword) {
      query += `&search_keyword=${search_keyword}`;
    }
    if (bill_id) {
      query += `&bill_id=${bill_id}`;
    }
    if (challan_created_from) {
      query += `&challan_created_from=${challan_created_from}`;
    }

    if (challan_created_to) {
      query += `&challan_created_to=${challan_created_to}`;
    }
    if (apcompany) {
      query += `&ap_company=${apcompany}`;
    }

    query += `&page=${queryPage}&limit=${queryLimit}`;

    navigate('/dashboard/challan' + query, {
      replace: true,
    });
    getChalan(customer_company_id || '', apcompany, id, '', `${queryPage}`, `${queryLimit}`);
  };

  useEffect(() => {
    const id = auths?.user?.customer_company?._id;

    if (filter || onSearch) {
      let bi = '';
      if (bill === null) {
        bi = '';
      } else if (bill === 'YES') {
        bi = 'YES';
      } else if (bill === 'NO') {
        bi = 'NO';
      } else {
        bi = 'YES';
      }
      let lod = '';
      if (leftDelivery === null) {
        lod = '';
      } else if (leftDelivery === 'YES') {
        lod = 'YES';
      } else if (leftDelivery === 'NO') {
        lod = 'NO';
      } else {
        lod = 'YES';
      }

      let cusAcc = '';
      if (clientAccept === null) {
        cusAcc = '';
      } else if (clientAccept === 'YES') {
        cusAcc = 'YES';
      } else if (clientAccept === 'NO') {
        cusAcc = 'NO';
      } else {
        cusAcc = 'YES';
      }

      navigate(
        `/dashboard/challan?ap_company=${selectedApCompany}&customer_company_id=${selectedCompany}&challan_search=${challanSearch}&job_search=${jobSearch}&bill_created=${bi}&left_for_delivery=${lod}&cust_accept=${cusAcc}&challan_created_from=${createdDateFrom}&challan_created_to=${createdDateTo}`,
        {
          replace: true,
        }
      );
      getChalan(selectedCompany, selectedApCompany, id, '');
      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, onSearch]);

  const getChalan = async (
    selectedCompany,
    selectedApCompany,
    id,
    bill_id,
    pageProp,
    limitProp
  ) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      let allChalans = [];
      let bi = '';

      if (bill === null) {
        bi = '';
      } else if (bill === 'YES') {
        bi = 'YES';
      } else if (bill === 'NO') {
        bi = 'NO';
      } else {
        bi = 'YES';
      }

      let lod = '';
      if (leftDelivery === null) {
        lod = '';
      } else if (leftDelivery === 'YES') {
        lod = 'YES';
      } else if (leftDelivery === 'NO') {
        lod = 'NO';
      } else {
        lod = 'YES';
      }

      let cusAcc = '';
      if (clientAccept === null) {
        cusAcc = '';
      } else if (clientAccept === 'YES') {
        cusAcc = 'YES';
      } else if (clientAccept === 'NO') {
        cusAcc = 'NO';
      } else {
        cusAcc = 'YES';
      }

      let url = '';

      let queryPage = searchParams.get('page');
      let queryLimit = searchParams.get('limit');
      if (pageProp) {
        queryPage = pageProp;
      }
      if (limitProp) {
        queryLimit = limitProp;
      }

      queryPage ? (queryPage = Number(queryPage) + 1) : (queryPage = page + 1);
      queryLimit ? (queryLimit = Number(queryLimit)) : (queryLimit = rowsPerPage);

      if (userData.type === 'customer_user') {
        url = `/api/v1/${userData.type}/${id}/challan?bill_id=${bill_id}&challan_search=${challanSearch}&job_search=${jobSearch}&challan_created_from=${createdDateFrom}&challan_created_to=${createdDateTo}&bill_created=${bi}&challan_uploaded=${cusAcc}&left_delivery=${lod}&customer_company_id=${selectedCompany}&page=${queryPage}&limit=${queryLimit}&challan_created_from=${createdDateFrom}&challan_created_to=${createdDateTo}`;
      } else {
        url = `/api/v1/${userData.type}/challan?ap_company_id=${selectedApCompany}&bill_id=${bill_id}&challan_search=${challanSearch}&job_search=${jobSearch}&challan_created_from=${createdDateFrom}&challan_created_to=${createdDateTo}&bill_created=${bi}&challan_uploaded=${cusAcc}&left_delivery=${lod}&customer_company_id=${selectedCompany}&page=${queryPage}&limit=${queryLimit}`;
      }

      const { data } = await axios.get(url, config);
      let challanIds = [];
      if (data.success) {
        setTotal(data.data.metadata.total_results);
        console.log(data.data.data);
        data.data.data.map((challan) => {
          allChalans.push(
            createData(
              challan.challan_id,
              challan.name,
              challan.customer_company.name,
              challan.description,
              challan
            )
          );
        });

        data?.data?.data.map((challan) => {
          challanIds.push(challan._id);
        });
        if (userData?.type === "super_admin") {
          const csvData = await axios.post(
            `api/v1/${authData?.type}/challan/getCsvData`,
            { challanIds },
            config
          );
          let finalChallanData = [];
          csvData.data.data.forEach((challanElement) => {
            challanElement.jobs.forEach((job) => {
              // Directly access the properties of the `plates` object
              const plate = job.plates;
              finalChallanData.push({
                challan_id: challanElement.challan.challan_id,
                challan_name: challanElement.challan.name,
                description: challanElement.challan.description,
                customer_company: challanElement.challan.customer_company?.name || 'N/A',
                challan_date: challanElement.challan.challan_date.slice(0, 10),
                job_id: job.job_id,
                plate_name: `${job.platesInfo?.height}x${job.platesInfo?.width}x${job.platesInfo?.thickness}`,
                baking_cost: plate.baking_cost,
                baking_quantity: plate.bake,
                print_cost: plate.print_cost,
                print_quantity: plate.printout,
                selling_cost: plate.selling_cost,
                plate_quantity: plate.quantity,
                row_cost: (
                  plate.baking_cost * plate.bake +
                  plate.print_cost * plate.printout +
                  plate.selling_cost * plate.quantity
                ).toFixed(2),
                row_cost_with_taxes: (
                  (plate.baking_cost * plate.bake +
                    plate.print_cost * plate.printout +
                    plate.selling_cost * plate.quantity) * 1.18
                ).toFixed(2),
                cost: challanElement.challan.totalPrice ?? 0,
              });
            });
          });
          setCsvChallanData(finalChallanData);
        }
      }

      setRows(allChalans);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  useEffect(() => {
    setUser(auths.user);
    if (
      auths?.user?.role?.permissions.includes('download_challan_pdf') ||
      authData?.type === 'super_admin'
    ) {
      setDownload(true);
    }
    if (
      auths?.user?.role?.permissions.includes('view_challan_details') ||
      authData?.type === 'super_admin'
    ) {
      setViewPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('update_challan_details') ||
      authData?.type === 'super_admin'
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('delete_challan') ||
      authData?.type === 'super_admin'
    ) {
      setDeletePermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('download_csv') ||
      authData?.type === 'super_admin'
    ) {
      setCsvPermission(true);
    }
  }, [auths.user]);

  return (
    <React.Fragment>
      <Helmet title='Alpha Plus' />
      {loader ? (
        <Loading />
      ) : (
        <>
          <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
            <Grid item>
              <Typography
                variant='h4'
                gutterBottom
                display='inline'
                sx={{ fontWeight: 600 }}
                color='primary'
              >
                CHALLAN
              </Typography>
            </Grid>
            <Grid item>
              <Breadcrumbs aria-label='Breadcrumb' mt={2}>
                <Link component={NavLink} to='/dashboard/tasks'>
                  Dashboard
                </Link>
                <Typography>Challan</Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>

          <Grid container spacing={6}>
            <Grid item xs={12}>
              <EnhancedTable
                getChalan={getChalan}
                setOnSearch={setOnSearch}
                challan_id={challanSearch}
                job_id={jobSearch}
                setJobSearch={setJobSearch}
                setChallanSearch={setChallanSearch}
                user={user}
                setFilter={setFilter}
                auths={auths}
                setBill={setBill}
                setRows={setRows}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                rows={rows}
                bill={bill}
                leftDelivery={leftDelivery}
                setLeftDelivery={setLeftDelivery}
                clientAccept={clientAccept}
                setClientAccept={setClientAccept}
                download={download}
                viewPermission={viewPermission}
                editPermission={editPermission}
                deletePermission={deletePermission}
                up={up}
                setUp={setUp}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPage={rowsPerPage}
                total_results={total}
                createdDateFrom={createdDateFrom}
                setCreatedDateFrom={setCreatedDateFrom}
                createdDateTo={createdDateTo}
                setCreatedDateTo={setCreatedDateTo}
                searchType={searchType}
                setSearchType={setSearchType}
                setSelectedApCompany={setSelectedApCompany}
                selectedApCompany={selectedApCompany}
                csvPermission={csvPermission}
                selectedChallanIds={selectedChallanIds}
                setSelectedChallanIds={setSelectedChallanIds}
                csvChallanData={csvChallanData}
              />
            </Grid>
          </Grid>
        </>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(Chalan);